import { useState, useEffect } from "react";
import { isAxiosError } from "axios";
import { api } from "../../utils/api";

interface QRCodeData {
  qrCode: string;
  secretCode: string;
}

export const useQRCode = (token: string | null) => {
  const [qrCode, setQrCode] = useState<QRCodeData | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!token) return; // без токена не робимо запит

    const fetchQRCode = async () => {
      setLoading(true);
      setError(null);

      try {
        const res = await api.get("/auth-user/auth-code-sign-up", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        setQrCode(res.data.authQRCode); // якщо бекенд повертає { qrCode, secretCode }
      } catch (err) {
        if (isAxiosError(err)) {
          setError(err.response?.data?.message || err.message);
        } else if (err instanceof Error) {
          setError(err.message);
        } else {
          setError("Unknown error");
        }
      }
    };

    fetchQRCode();
  }, [token]);

  return { qrCode, loading, error };
};
